export default "__VITE_ASSET__xnRSDc$r__"